"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: Object.getOwnPropertyDescriptor(all, name).get
    });
}
_export(exports, {
    get BOOKING_WARNING_CODES () {
        return BOOKING_WARNING_CODES;
    },
    get clinicDayOpeningWindow () {
        return clinicDayOpeningWindow;
    },
    get evaluateBookingWarnings () {
        return evaluateBookingWarnings;
    },
    get resolveDefaultDurationMinutes () {
        return resolveDefaultDurationMinutes;
    }
});
const _time = require("./time");
const BOOKING_WARNING_CODES = [
    'CLINIC_CLOSED',
    'OUTSIDE_CLINIC_HOURS',
    'OUTSIDE_DOCTOR_AVAILABILITY'
];
/** The clinic a booking is checked against, or `null` when it can't be told. */ function resolveBranch(day, branchId) {
    if (branchId !== undefined && branchId !== null) {
        return day.branches.find((branch)=>branch.branchId === branchId) ?? null;
    }
    if (day.branches.length === 1) {
        return day.branches[0];
    }
    return null;
}
function isCovered(merged, start, end) {
    return merged.some((interval)=>interval.startMinutes <= start && end <= interval.endMinutes);
}
function evaluateBookingWarnings(day, booking) {
    if (!_time.CLINIC_TIME_PATTERN.test(booking.start) || !Number.isInteger(booking.durationMinutes) || booking.durationMinutes <= 0) {
        return [];
    }
    const start = (0, _time.clinicTimeToMinutes)(booking.start);
    const end = start + booking.durationMinutes;
    const endsToday = end <= _time.MINUTES_PER_DAY;
    const warnings = [];
    const branch = resolveBranch(day, booking.branchId);
    if (branch !== null) {
        const isClosed = branch.holiday !== null || branch.hours.isSet && branch.hours.intervals.length === 0;
        if (isClosed) {
            warnings.push('CLINIC_CLOSED');
        } else if (branch.hours.isSet) {
            const merged = (0, _time.mergeTimeIntervals)(branch.hours.intervals);
            if (!endsToday || !isCovered(merged, start, end)) {
                warnings.push('OUTSIDE_CLINIC_HOURS');
            }
        }
    }
    if (day.doctorsWithAvailability.includes(booking.providerUserId)) {
        const own = day.availability.filter((row)=>row.userId === booking.providerUserId);
        const branchIds = branch !== null ? [
            branch.branchId
        ] : [
            ...new Set(own.map((row)=>row.branchId))
        ];
        const isAvailable = endsToday && branchIds.some((branchId)=>isCovered((0, _time.mergeTimeIntervals)(own.filter((row)=>row.branchId === branchId)), start, end));
        if (!isAvailable) {
            warnings.push('OUTSIDE_DOCTOR_AVAILABILITY');
        }
    }
    return warnings;
}
function branchWindow(branch) {
    if (branch.holiday !== null) {
        return {
            kind: 'closed',
            holiday: branch.holiday
        };
    }
    if (!branch.hours.isSet) {
        return {
            kind: 'not_set'
        };
    }
    const first = branch.hours.intervals[0];
    if (first === undefined) {
        return {
            kind: 'closed',
            holiday: null
        };
    }
    let start = first.start;
    let end = first.end;
    for (const interval of branch.hours.intervals){
        if (interval.start < start) {
            start = interval.start;
        }
        if (interval.end > end) {
            end = interval.end;
        }
    }
    return {
        kind: 'open',
        start,
        end
    };
}
function clinicDayOpeningWindow(day, branchId) {
    if (branchId !== undefined && branchId !== null) {
        const branch = day.branches.find((candidate)=>candidate.branchId === branchId);
        if (branch === undefined) {
            return {
                kind: 'not_set'
            };
        }
        return branchWindow(branch);
    }
    if (day.branches.length === 0) {
        return {
            kind: 'not_set'
        };
    }
    if (day.branches.length === 1) {
        return branchWindow(day.branches[0]);
    }
    const windows = day.branches.map(branchWindow);
    let start = null;
    let end = null;
    for (const window of windows){
        if (window.kind === 'open') {
            if (start === null || window.start < start) {
                start = window.start;
            }
            if (end === null || window.end > end) {
                end = window.end;
            }
        }
    }
    if (start !== null && end !== null) {
        return {
            kind: 'open',
            start,
            end
        };
    }
    if (windows.every((window)=>window.kind === 'closed')) {
        return {
            kind: 'closed',
            holiday: null
        };
    }
    return {
        kind: 'not_set'
    };
}
function resolveDefaultDurationMinutes(day, input) {
    if (!_time.CLINIC_TIME_PATTERN.test(input.start)) {
        return null;
    }
    const match = day.availability.find((row)=>row.userId === input.providerUserId && (input.branchId === undefined || input.branchId === null || row.branchId === input.branchId) && row.start <= input.start && input.start < row.end);
    return match?.defaultDurationMinutes ?? null;
}
